<mat-card>
    <hq-empty-state heading="Looks like you found a page we haven't built"
                    icon="build">
    </hq-empty-state>
</mat-card>
